import { removeErrorStackInitiator } from '@app/utils/removeStackInitiator'

import type { Location, LocationInit } from './types'
import { createLocation } from './utils'

export class RedirectError extends Error {
  location!: Location
  permanent = false

  static create(location: LocationInit, permanent = false) {
    const err = new RedirectError(`Redirecting: ${location.pathname}`)
    err.location = createLocation(location)
    err.permanent = permanent
    removeErrorStackInitiator(err)
    return err
  }
}
